import type { CoefficientRange, CoefficientResponse, CoefficientType } from '@shared-types/coefficient.types';
import { language } from '@utilities/browser';
import { uniqBy } from '@utilities/collection-utils';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, compApiUrl, fspApiLimit } from '@utilities/WindowContext';

export type FetchCoefficientsParams = {
  coefficientType: CoefficientType;
  coefficientRange: CoefficientRange;
  seasonYear?: string;
  memberId?: string;
};

const pagesize = fspApiLimit ?? 50;

export const fetchCoefficients = async (filters: FetchCoefficientsParams, signal?: AbortSignal) => {
  let result: CoefficientResponse = {
    members: [],
  };
  let tempResult: CoefficientResponse;
  let page = 1;

  do {
    tempResult = (
      await loadFromAPIs<{ data: CoefficientResponse }>(
        `v2/coefficients`,
        {
          ...filters,
          page,
          pagesize,
          language: language.toUpperCase(),
        },
        { apiKey, apiUrl: compApiUrl, signal },
      )
    )?.data;

    page++;
    if (tempResult?.members?.length) {
      result = {
        members: uniqBy([...result.members, ...tempResult.members], (m) => m.member.id),
        lastUpdateDate: tempResult.lastUpdateDate,
      };
    }
    if (!tempResult?.members?.length || tempResult.members.length < pagesize) break;
  } while (tempResult?.members?.length || page < 10);

  return result;
};
